import DetailPersonnePhysique from '@/view/personnephysique/DetailPersonnePhysique';
import DetailPersonneMorale from '@/view/personnemorale/DetailPersonneMorale';
import DetailInstance from '@/view/instance/DetailInstance';
import RemplacerContact from '@/view/personnephysique/RemplacerContact';
import CreationMasseContact from '@/view/personnephysique/CreationMasseContact';
import ListDemande from '@/view/workflow/ListDemande';
import ListMesDemandes from '@/view/workflow/ListMesDemandes';
import DetailDemandePersonneMorale from '@/view/workflow/DetailDemandePersonneMorale';
import DetailDemandePersonnePhysique from '@/view/workflow/DetailDemandePersonnePhysique';
import DetailDemandePersonnePhysiqueMobile from '@/view/workflow/DetailDemandePersonnePhysiqueMobile';
import DetailDemandeInstance from '@/view/workflow/DetailDemandeInstance';
import DetailDemandeInscription from '@/view/workflow/DetailDemandeInscription';

const WORKFLOW_BREADCRUMB = {
  code: 'menu.workflow.demande.validation.title',
  link: {
    name: 'workflow/demande',
  },
};

const MYWORKFLOW_BREADCRUMB = {
  code: 'menu.workflow.mesDemandes.title',
  link: {
    name: 'workflow/mesdemandes',
  },
};

export default [
  {
    path: '/demandecreation/personnephysique',
    name: 'demandecreation/personnephysique',
    component: DetailPersonnePhysique,
    props: {
      enModeCreation: true,
      enDemandeCreation: true,
    },
    meta: {
      auth: 'hasRole(PRIV_DEMANDE_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [
        { code: 'menu.workflow.demande.creation.personnePhysique' },
      ],
    },
  },
  {
    path: '/creation-masse-contact',
    name: 'workflow/creation-masse-contact',
    component: CreationMasseContact,
    meta: {
      auth: 'hasRole(PRIV_DEMANDE_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [{ code: 'personnePhysique.creation-masse.title' }],
    },
  },
  {
    path: '/demandecreation/personnemorale',
    name: 'demandecreation/personnemorale',
    component: DetailPersonneMorale,
    props: {
      enModeCreation: true,
      enDemandeCreation: true,
    },
    meta: {
      auth: 'hasRole(PRIV_DEMANDE_PERSONNE_MORALE_WRITE)',
      breadcrumb: () => [
        {
          code: 'menu.workflow.demande.creation.personneMorale',
        },
      ],
    },
  },

  {
    path: '/remplacer-contact',
    name: 'workflow/remplacer-contact',
    component: RemplacerContact,
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [{ code: 'personnePhysique.remplacerContact.title' }],
    },
  },
  {
    path: '/demandecreation/instance',
    name: 'demandecreation/instance',
    component: DetailInstance,
    props: {
      enModeCreation: true,
      enDemandeCreation: true,
    },
    meta: {
      auth: 'hasRole(PRIV_DEMANDE_INSTANCE_WRITE)',
      breadcrumb: () => [
        {
          code: 'menu.workflow.demande.creation.instance',
        },
      ],
    },
  },
  {
    path: '/validation/demande',
    name: 'workflow/demande',
    component: ListDemande,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE, PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE, PRIV_TRAITEMENT_DEMANDE_CONTACT, PRIV_TRAITEMENT_DEMANDE_INSTANCE, PRIV_TRAITEMENT_DEMANDE_INSCRIPTION)',
      breadcrumb: () => [{ code: 'menu.workflow.demande.validation.title' }],
    },
  },
  {
    path: '/validation/mesdemandes',
    name: 'workflow/mesdemandes',
    component: ListMesDemandes,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_DEMANDE_PERSONNE_PHYSIQUE_WRITE, PRIV_DEMANDE_CONTACT_WRITE,  PRIV_DEMANDE_PERSONNE_MORALE_WRITE, PRIV_DEMANDE_INSTANCE_WRITE)',
      breadcrumb: () => [{ code: 'menu.workflow.mesDemandes.title' }],
    },
  },
  {
    path: '/validation/personnemorale/:id',
    name: 'workflow/demande/personnemorale/detail',
    component: DetailDemandePersonneMorale,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE, PRIV_DEMANDE_PERSONNE_MORALE_WRITE)',
      breadcrumb: () => [
        WORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personneMorale' },
      ],
    },
  },

  {
    path: '/validation/instance/:id',
    name: 'workflow/demande/instance/detail',
    component: DetailDemandeInstance,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_INSTANCE, PRIV_DEMANDE_INSTANCE_WRITE)',
      breadcrumb: () => [
        WORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.instance' },
      ],
    },
  },

  {
    path: '/validation/personne-physique/:id',
    name: 'workflow/demande/personne-physique/detail',
    component: DetailDemandePersonnePhysique,
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE, PRIV_DEMANDE_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [
        WORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },

  {
    path: '/validation/personne-mobile/:id',
    name: 'workflow/demande/personne-mobile/detail',
    component: DetailDemandePersonnePhysiqueMobile,
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_CONTACT, PRIV_DEMANDE_CONTACT_WRITE)',
      breadcrumb: () => [
        WORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },

  {
    path: '/validation/inscription/:id',
    name: 'workflow/demande/inscription/detail',
    component: DetailDemandeInscription,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_INSCRIPTION, PRIV_TRAITEMENT_DEMANDE_INSCRIPTION_WRITE)',
      breadcrumb: () => [
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },

  {
    path: '/mesdemandes/validation/personnemorale/:id',
    name: 'workflow/mesdemandes/personnemorale/detail',
    component: DetailDemandePersonneMorale,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE, PRIV_DEMANDE_PERSONNE_MORALE_WRITE)',
      breadcrumb: () => [
        MYWORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personneMorale' },
      ],
    },
  },

  {
    path: '/mesdemandes/validation/instance/:id',
    name: 'workflow/mesdemandes/instance/detail',
    component: DetailDemandeInstance,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_INSTANCE, PRIV_DEMANDE_INSTANCE_WRITE)',
      breadcrumb: () => [
        MYWORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.instance' },
      ],
    },
  },

  {
    path: '/mesdemandes/validation/personne-physique/:id',
    name: 'workflow/mesdemandes/personne-physique/detail',
    component: DetailDemandePersonnePhysique,
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE, PRIV_DEMANDE_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [
        MYWORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },

  {
    path: '/mesdemandes/validation/personne-mobile/:id',
    name: 'workflow/mesdemandes/personne-mobile/detail',
    component: DetailDemandePersonnePhysiqueMobile,
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_CONTACT, PRIV_DEMANDE_CONTACT_WRITE)',
      breadcrumb: () => [
        MYWORKFLOW_BREADCRUMB,
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },

  {
    path: '/mesdemandes/validation/inscription/:id',
    name: 'workflow/mesdemandes/inscription/detail',
    component: DetailDemandeInscription,
    props: {},
    meta: {
      auth:
        'hasRole(PRIV_TRAITEMENT_DEMANDE_INSCRIPTION, PRIV_TRAITEMENT_DEMANDE_INSCRIPTION_WRITE)',
      breadcrumb: () => [
        { code: 'menu.workflow.demande.validation.personnePhysique' },
      ],
    },
  },
];
